import axiosInstance from "../config/apiInterceptor.config";

const COMPARABLES_URI = process.env.REACT_APP_COMPARABLES_URI;

export const SEARCH_ACTIONS = {
  CLEAR_ALL: "clearAll",
  CLEAR_ALL_BUT_SUGGESTIONS: "clearAllButSuggestions",
  CLEAR_ALL_BUT_CADASTRAL_MATCH: "clearAllButCadastralMatch",
  SELECT_SUGGESTION: "selectSuggestion",
  UPDATE_SELECTED_ADDRESS: "updateSelectedAddress",
  UPDATE_FILTERED_RESULTS: "updateFilteredResults",
  UPDATE_SELECTED_PORTAL: "updateSelectedPortal",
  UPDATE_COORDS: "updateCoords",
  UPDATE_POSTAL_CODE: "updatePostalCode",
  UPDATE_CADASTRAL_SUGGESTIONS: "updateCadastralSuggestions",
  UPDATE_CADASTRAL_EXACT_MATCH: "updateCadastralExactMatch",
  NO_PORTALS_FOUND: "noPortalsFound",
  NO_HOUSES_FOUND: "noHousesFound",
  UPDATE_PORTALS: "updatePortals",
  UPDATE_RECOMMENDED: "updateRecommended",
  SELECT_OPTION: "selectOption",
  RETRIEVE_ASSET_ADDRESS_INFO: "retrieveAssetAddressInfo",
  IFRAME_KEY: "iframeKey",
};

export const initialState = {
  iframeKey: "",
  filteredResults: [],
  cadastralSuggestions: [],
  selectedAddress: false,
  coords: [],
  postalCode: "",
  portals: [],
  selectedPortal: "",
  recommendedNumbers: [],
  cadastralExactMatch: [],
  selectedOption: {},
  noPortalsFound: false,
  noHousesFound: false,
};

export function searchReducer(state, action) {
  switch (action.type) {
    case "clearAll":
      return { ...initialState, iframeKey: state.iframeKey };
    case "clearAllButSuggestions":
      return {
        ...initialState,
        iframeKey: state.iframeKey,
        cadastralSuggestions: state.cadastralSuggestions,
      };
    case "clearAllButCadastralMatch":
      return {
        ...initialState,
        iframeKey: state.iframeKey,
        cadastralExactMatch: state.cadastralExactMatch,
      };
    case "iframeKey":
      return { ...state, iframeKey: action.payload.iframeKey };
    case "updateCadastralSuggestions":
      return {
        ...state,
        cadastralSuggestions: action.payload.cadastralSuggestions,
      };
    case "selectOption":
      return { ...state, selectedOption: action.payload.selectedOption };
    case "updateSelectedAddress":
      return { ...state, selectedAddress: action.payload.selectedAddress };
    case "retrieveAssetAddressInfo":
      return {
        selectedPortal: state.selectedPortal,
        assetStaircase: state.selectedOption,
      };
    case "selectSuggestion":
      return selectSuggestion(
        state,
        action.payload.query,
        action.payload.dispatch,
        action.payload.postalCode,
        action.payload.coords,
        action.payload.selectedAddress
      );
    case "updateFilteredResults":
      return { ...state, filteredResults: action.payload.filteredResults };
    case "updateCadastralExactMatch":
      return {
        ...state,
        cadastralExactMatch: action.payload.cadastralExactMatch,
      };
    case "updateSelectedPortal":
      return { ...state, selectedPortal: action.payload.selectedPortal };
    case "noPortalsFound":
      return { ...state, noPortalsFound: action.payload.noPortalsFound };
    case "noHousesFound":
      return { ...state, noHousesFound: action.payload.noHousesFound };
    case "updatePortals":
      return { ...state, portals: action.payload.portals };
    case "updateRecommended":
      return {
        ...state,
        recommendedNumbers: action.payload.recommendedNumbers,
      };
    case "updateCoords":
      return { ...state, coords: action.payload.coords };
    case "updatePostalCode":
      return { ...state, postalCode: action.payload.postalCode };
    default:
      return state;
  }
}

async function selectSuggestion(
  state,
  query,
  dispatch,
  postalCode,
  coords,
  selectedAddress
) {
  await axiosInstance
    .get(
      `${COMPARABLES_URI}cadastral?address=${encodeURIComponent(
        query
      )}&typology_type=1`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${state.iframeKey}`,
        },
      }
    )
    .then((response) => {
      if (response.data.code === 400) {
        dispatch({ type: SEARCH_ACTIONS.NO_PORTALS_FOUND });
      } else if (response.data.code === 200 && response.data.type === "exact") {
        const results = response.data.results;
        if (results.length === 0) {
          dispatch({ type: SEARCH_ACTIONS.NO_HOUSES_FOUND });
        } else {
          dispatch({
            type: SEARCH_ACTIONS.UPDATE_FILTERED_RESULTS,
            payload: { filteredResults: results },
          });
        }
      } else if (
        response.data.code === 200 &&
        response.data.type === "portals"
      ) {
        dispatch({
          type: SEARCH_ACTIONS.UPDATE_PORTALS,
          payload: { portals: response.data.results },
        });
      } else if (
        response.data.code === 200 &&
        response.data.type === "recommended"
      ) {
        dispatch({
          type: SEARCH_ACTIONS.UPDATE_RECOMMENDED,
          payload: {
            recommendedNumbers: response.data.results.map((portal) =>
              portal.replace(/\s/g, "")
            ),
          },
        });
      }
    });

  return {
    ...state,
    postalCode: postalCode,
    coords: coords,
    selectedAddress: selectedAddress,
  };
}
